function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

export const relativeTime = (date) => {
  const d = toDate(date);
  if (!d) return '-';
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 0) return 'just now';
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
};

export const exactTime = (date) => {
  const d = toDate(date);
  if (!d) return '-';
  return d.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
    timeZoneName: 'short',
  });
};

export const formatDate = (date) => {
  const d = toDate(date);
  if (!d) return '-';
  return d.toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
};

export const ago = (h, d = 0) => new Date(Date.now() - h * 3600000 - d * 86400000);
